import { useIsUserC360 } from '@/features/account/services/User/hooks'
import { HDivider } from '@/features/shared/components/Dividers'
import { C360Logo } from '@/features/shared/components/C360Logo'
import { useIsPage } from '@/features/shared/hooks/useIsPage'
import { Column } from '@shipt/design-system-layouts'
import { Body, Headline } from '@shipt/design-system-typography'
import styled from 'styled-components'

export const OrderDetailsShelfHeader = () => {
  const isC360User = useIsUserC360()
  const { ORDER_DETAIL } = useIsPage()
  if (!ORDER_DETAIL) return null

  return (
    <Column align="center" padding={['lg', 'lg', 0]} spacing="sm">
      <Headline>Shop more stores near you</Headline>
      <Body variant="secondary" align="center">
        {isC360User ? (
          <>
            <C360Logo /> gives you same-day delivery from other stores with no markups via Shipt.
          </>
        ) : (
          'Free same-day delivery from other stores via Shipt.'
        )}
      </Body>
      <Divider />
    </Column>
  )
}

const Divider = styled(HDivider)`
  margin: 0;
`
